<template>
  <ul class="menu">
    <li class="menu-list" v-for="(list, index) in menuList" :key="index" @click="tabChange(list, index)">
      <img v-if="currentIndex === index" class="menu-icon" :src="list.activeIcon" alt="active">
      <img v-else class="menu-icon" :src="list.icon" alt="icon" />
      <span :class="{ 'menu-title': true, 'active': currentIndex === index }">{{ list.name }}</span>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'LayoutMenu',
    data() {
      return {
        currentIndex: 0,
        menuList: [
          // {
          //   name: '学习计划',
          //   path: '/plan',
          //   icon: require('@/assets/image/plan.png'),
          //   activeIcon: require('@/assets/image/planActive.png')
          // },
          {
            name: '我的课程',
            path: '/course',
            icon: require('@/assets/image/course.png'),
            activeIcon: require('@/assets/image/courseActive.png')
          },
          {
            name: '万课会员',
            path: '/vip',
            icon: require('@/assets/image/order.png'),
            activeIcon: require('@/assets/image/orderActive.png'),
          },


          // {
          //   name: '我的订单',
          //   path: '/order',
          //   icon: require('@/assets/image/order.png'),
          //   activeIcon: require('@/assets/image/orderActive.png'),
          // },
          // {
          //   name: '我的顾问',
          //   path: '/adviser',
          //   icon: require('@/assets/image/adviser.png'),
          //   activeIcon: require('@/assets/image/adviserActive.png'),
          // },
          // {
          //   name: '我的收藏',
          //   path: '/collection',
          //   icon: require('@/assets/image/collection.png'),
          //   activeIcon: require('@/assets/image/collectionActive.png'),
          // },
          // {
          //   name: '结业证',
          //   path: '/certificate',
          //   icon: require('@/assets/image/certificate.png'),
          //   activeIcon: require('@/assets/image/certificateActive.png'),
          // },
        ]
      }
    },
    methods: {
      // 菜单切换
      tabChange(list, index) {
        this.currentIndex = index
        this.$route.path !== list.path && this.$router.push(list.path)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .menu {
    margin: 30px 0 52px 93px;

    .menu-list {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 22px 0;

      .menu-icon {
        width: 20px;
        height: 20px;
        margin-right: 15px;
      }

      .menu-title {
        &.active {
          color: $theme-color;
        }
      }
    }
  }
</style>